import { render, staticRenderFns } from "./EditRoomBookingDailyPriceTable.vue?vue&type=template&id=703c6ae2"
import script from "./EditRoomBookingDailyPriceTable.vue?vue&type=script&lang=js"
export * from "./EditRoomBookingDailyPriceTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports